export default "__VITE_ASSET__BSlXYhV___"